module.exports = __webpack_public_path__ + "static/img/1809104.e74e9bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/180910/1809104.jpg
// module id = VzrN
// module chunks = 0